<template>
  <!-- 
  费率有三种
  1  普通用户费率
     有交/直流桩才显示交/直费率
    当前的:   currentPrice 里面  vipType = 1
    列表的   acElecpricePartDescPos 交流列表  dcElecpricePartDescPos直流列表

  2  普通用户:该站点有活动调价 ,
      交 campaignAcElecPricePartDescPos
      直 campaignDcElecPricePartDescPos
    当前的 :  对比费率时间，选出当前时段的费率，拿到里面的电费+服务费,显示两个费率,划掉第一个费率(currentPrice)
    列表的:  直接显示 00:00 ~ 24:00  用活动里的价格

  3 企业优惠
    当前的:   currentPrice 里面  vipType != 1
    列表的 : entAcElecPricePartDescPos 交    entDcElecPricePartDescPos 直    entAcDelayPricePartDescPos 交流延时费   entDcDelayPricePartDescPos 直流延时费
 -->
  <div class="station" v-if="feeDetail">
    <div class="rate-details" v-if="feeDetail.ifHlht">
      <h2 class="rate-details-title">费用详情</h2>
      <div class="rate-list" style="margin: 0 0.1rem">
        <ul>
          <li class="rate-list-title" style="padding-bottom: 0">电费</li>
          <li class="rate-list-item" style="color: #666">
            {{ feeDetail.hlhtStaInfo.electricityFee }}
          </li>
        </ul>
        <ul>
          <li class="rate-list-title" style="padding-bottom: 0">服务费</li>
          <li class="rate-list-item" style="color: #666">
            {{ feeDetail.hlhtStaInfo.serviceFee }}
          </li>
        </ul>
      </div>
    </div>
    <template v-else>
      <div class="rate-info">
        <div class="cell-row">
          <div class="rate-title">当前费用</div>
          <div
            class="rate-info-box"
            v-for="(item, index) in feeDetail.currentPrice"
            :key="index"
          >
            <div class="rate-info-time">
              <img
                class="ent-pay-img"
                src="../../../../assets/img/ent-pay.png"
                v-if="item.vipType != 1"
              />
            </div>
            <div
              class="rate-info-time delaye-time"
              v-if="
                feeDetail.acDelayFreeMinutes != null ||
                feeDetail.dcDelayFreeMinutes != null
              "
            >
              免费时长：
              <template v-if="details.dcGunTotalCount > 0 || noPile">
                直 {{ feeDetail.dcDelayFreeMinutes || "-" }}分钟
              </template>
              <template
                v-if="
                  (details.dcGunTotalCount > 0 &&
                    details.acGunTotalCount > 0) ||
                  noPile
                "
                >/</template
              >
              <template v-if="details.acGunTotalCount > 0 || noPile">
                交 {{ feeDetail.acDelayFreeMinutes || "-" }}分钟
              </template>
            </div>
            <div class="rate-details-btn" @click="goFee(item.vipType)">
              价格详情
            </div>

            <div
              class="rate-info-item dc"
              v-if="details.dcGunTotalCount > 0 || noPile"
            >
              <span
                :class="
                  campaignFee.dc && item.vipType == 1
                    ? 'no-money'
                    : 'rate-number orange'
                "
                >{{ item.dcElecFee }}</span
              >
              <span
                class="rate-number orange"
                v-if="campaignFee.dc && item.vipType == 1"
                >{{ campaignFee.dc }}</span
              >
              <span class="rate-unit">元/度</span>
              <span class="rate-type">直流</span>
            </div>
            <div
              class="rate-info-item ac"
              v-if="details.acGunTotalCount > 0 || noPile"
            >
              <span
                :class="
                  campaignFee.ac && item.vipType == 1
                    ? 'no-money'
                    : 'rate-number green'
                "
                >{{ item.acElecFee }}</span
              >
              <span
                class="rate-number green"
                v-if="campaignFee.ac && item.vipType == 1"
                >{{ campaignFee.ac }}</span
              >
              <span class="rate-unit">元/度</span>
              <span class="rate-type">交流</span>
            </div>
            <template v-if="item.dcDelayFee">
              <div
                class="rate-info-item delay"
                v-if="details.dcGunTotalCount > 0 || noPile"
              >
                <span class="rate-number">{{ item.dcDelayFee }}</span>
                <span class="rate-unit">元/分</span>
                <span class="rate-type">延时费(直)</span>
              </div>
            </template>
            <template v-if="item.acDelayFee">
              <div
                class="rate-info-item delay"
                v-if="details.acGunTotalCount > 0 || noPile"
              >
                <span class="rate-number">{{ item.acDelayFee }}</span>
                <span class="rate-unit">元/分</span>
                <span class="rate-type">延时费(交)</span>
              </div>
            </template>
          </div>
        </div>
        <div class="cell-row-box">
          <div class="name">停车费用</div>
          <div class="text" v-if="details.hlht == '0'">
            {{ feeDetail.parkingFee || "--" }}
          </div>
          <div class="text" v-else>{{ details.parkInfo || "--" }}</div>
        </div>
        <div class="cell-row-box">
          <div class="name">运营商家</div>
          <div class="text">{{ details.oprName || "--" }}</div>
        </div>
        <div class="cell-row-box">
          <div class="name">服务电话</div>
          <div class="text" @click="openTel">
            {{ feeDetail.serviceTel || "--" }}
          </div>
        </div>
        <div class="cell-row-box">
          <div class="name">导航地址</div>
          <div class="text" @click="openLocation">
            {{ details.staAddress || "--" }}
            <span class="distance">{{ details.currentDistance }}km</span>
            <img
              class="nav-address"
              src="../../../../assets/img/position.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div
        :scroll-x="true"
        class="server-scroll-view"
        v-if="accretionServiceList.length > 0"
      >
        <div class="server-list">
          <div
            class="server-list-item"
            v-for="(item, index) in accretionServiceList"
            :key="index"
          >
            <img class="server-icon" :src="item.logoUrl" />
            <div class="server-name">{{ item.serviceName }}</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { getStationDetailFee, getStaAccretionService } from "@/common/api";
import UserTag from "@/view/my/components/pi-user-tag";
export default {
  name: "pi-station",
  components: {
    [UserTag.name]: UserTag,
  },
  data() {
    return {
      active: 0,
      feeDetail: null,
      // acUl: true,
      // dcUl: true,
      // delayUl: true,
      campaignFee: {},
      // delayedFee: null, //当前延时费
      accretionServiceList: [],
      noPile: false, // 没有桩的情况显示所有费率
    };
  },
  mounted() {
    this.getPriceInfo();
    this.getStaAccretionService();
  },
  props: {
    details: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    async getStaAccretionService() {
      let ret = await getStaAccretionService({ staPkId: this.details.staPkId });
      if (ret.status === 0) {
        ret.data.map((item) => {
          item.logoUrl = this.$config.fileUrl + item.logoUrl;
        });

        this.accretionServiceList = ret.data;
      }
    },
    getPriceInfo() {
      getStationDetailFee({
        staPkId: this.$route.query.staPkId,
      })
        .then((ret) => {
          if (ret.status === this.$config.ajaxStatus) {
            this.feeDetail = ret.data[0];
            let data = ret.data[0];
            let campaignFee = {};
            // 交流活动调价
            if (
              data.campaignAcElecPricePartDescPos &&
              data.campaignAcElecPricePartDescPos.length > 0
            ) {
              let campAc = this.timeItem(data.campaignAcElecPricePartDescPos);
              let acFee = campAc[0];
              campaignFee.ac = this.feeNumber(
                acFee.slotElecPrice + acFee.slotServicePrice
              );
              campaignFee.acElecPrice = acFee.slotElecPrice;
              campaignFee.acServicePrice = acFee.slotServicePrice;
            }
            // 直流调价费率
            if (
              data.campaignDcElecPricePartDescPos &&
              data.campaignDcElecPricePartDescPos.length > 0
            ) {
              let campDc = this.timeItem(data.campaignDcElecPricePartDescPos);
              let dcFee = campDc[0];
              campaignFee.dc = this.feeNumber(
                dcFee.slotElecPrice + dcFee.slotServicePrice
              );
              campaignFee.dcElecPrice = dcFee.slotElecPrice;
              campaignFee.dcServicePrice = dcFee.slotServicePrice;
            }

            this.campaignFee = campaignFee;
            this.$emit("feeSuccess", this.feeDetail);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goFee(viptype) {
      let type = viptype != 1 ? "ent" : "";
      this.$router.push(
        "/station-fee-details?staPkId=" +
          this.details.staPkId +
          "&type=" +
          type +
          "&dc=" +
          this.details.dcGunTotalCount +
          "&ac=" +
          this.details.acGunTotalCount
      );
    },
    openTel() {
      window.location.href = "tel:" + this.feeDetail.serviceTel;
    },
    openLocation() {
      this.$emit("goAddr");
    },
    getTimeNumber(time) {
      let arr = time.split(":");
      return arr[0] * 100 + parseInt(arr[1]);
    },
    timeItem(data) {
      var time = this.$common.thisTimes("HH:MM").split(":");
      let t = Number(time[0]) * 100 + Number(time[1]);
      var arr = data.filter((item) => {
        return t >= item.beginTime && t <= item.endTime;
      });
      if (arr.length == 0) {
        arr = data[0];
      }
      return arr;
    },
    feeNumber(slotElecPrice, slotServicePrice) {
      slotElecPrice = slotElecPrice || 0;
      slotServicePrice = slotServicePrice || 0;
      return parseFloat((slotElecPrice + slotServicePrice).toFixed(4));
    },
  },
};
</script>

<style lang="less">
.station {
  padding: 0.1rem;
  background-color: #fff;
  .server-scroll-view {
    background-color: #f7f7f7;
    margin-top: 0.2rem;
  }
  .server-list {
    display: flex;
    flex-wrap: wrap;
  }
  .server-list-item {
    padding: 0.15rem 0.3rem;
    text-align: center;
  }
  .server-list-item .server-icon {
    width: 0.6rem;
    height: 0.6rem;
    vertical-align: top;
  }
  .server-list-item .server-name {
    font-size: 0.28rem;
    color: #333;
    margin-top: 0.05rem;
  }

  .rate-info {
    padding: 0 0.2rem;
    flex: 1;
    overflow-y: auto;

    .pile-box {
      flex: 1;
      overflow-y: auto;
    }

    .cell-row,
    .cell-row-box {
      padding: 0.2rem 0;
      border-bottom: 1px solid #eeeeee;
    }

    .cell-row-box {
      display: flex;
    }

    .cell-row-box .text {
      flex: 1;
      color: #999999;
      font-size: 0.24rem;
      line-height: 0.33rem;
      text-align: right;
    }

    .cell-row-box .text .distance {
      margin-left: 0.1rem;
      color: #333;
    }

    .nav-address {
      display: inline-block;
      width: 0.38rem;
      height: 0.38rem;
      margin-left: 0.1rem;
      vertical-align: text-bottom;
    }

    .rate-title,
    .cell-row-box .name {
      font-size: 0.28rem;
      line-height: 0.4rem;
      color: #000;
      font-weight: 500;
    }

    .rate-info-box {
      margin-top: 0.1rem;
      padding: 0.1rem;
      background-color: #f7f7f7;
      border-radius: 0.1rem;
      position: relative;
    }
    .rate-info-time {
      font-size: 0.24rem;
      color: #666;
      line-height: 0.33rem;
    }
    .delaye-time {
      margin-top: 0.1rem;
    }
    .rate-details-btn {
      position: absolute;
      padding: 0.08rem 0.2rem;
      border-radius: 0.24rem;
      background-color: #ffffff;
      font-size: 0.24rem;
      line-height: 0.33rem;
      color: #666;
      right: 0.1rem;
      top: 0.1rem;
    }
    .rate-info-item {
      margin-top: 0.1rem;
      font-size: 0.28rem;
      line-height: 0.4rem;
    }
    .rate-info-item.ac {
      color: #14cc80;
    }
    .rate-info-item.dc {
      color: #ffa244;
    }
    .rate-info-item.delay {
      color: #333333;
    }
    .no-money {
      text-decoration: line-through;
      color: #999;
    }
    .rate-type {
      color: #666;
      margin-left: 0.38rem;
    }
    .rate-number {
      font-size: 0.48rem;
      line-height: 0.56rem;
    }
    .rate-box {
      margin-top: 0.1rem;
      display: flex;
      font-size: 0.28rem;
      line-height: 0.4rem;
    }

    .rate-box .rate-flex {
      flex: 1;
      color: #666666;
    }

    .rate-box .number {
      margin: 0 0.3rem 0 0.1rem;
    }

    .rate-box .number.green,
    .rate-details {
      color: #14cc80;
    }

    .rate-box .number.orange {
      color: #ffa244;
    }

    .rate-box .number.black {
      color: #000;
    }
  }
  .ent-pay-img {
    width: 0.96rem;
    height: 0.3rem;
    vertical-align: text-bottom;
  }
}
</style>
